(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[945],{

/***/ 6078:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all/[id]",
      function () {
        return __webpack_require__(1914);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/Page/index.js
var Page = __webpack_require__(7558);
// EXTERNAL MODULE: ./src/components/banner.js
var banner = __webpack_require__(111);
// EXTERNAL MODULE: ./src/components/productItem.js + 2 modules
var productItem = __webpack_require__(9070);
// EXTERNAL MODULE: ./src/api/api.js + 1 modules
var api = __webpack_require__(977);
// EXTERNAL MODULE: ./node_modules/react-paginate/dist/react-paginate.js
var react_paginate = __webpack_require__(1358);
var react_paginate_default = /*#__PURE__*/__webpack_require__.n(react_paginate);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./src/components/select.js
var components_select = __webpack_require__(1810);
// EXTERNAL MODULE: ./src/assets/images/browser.png
var browser = __webpack_require__(789);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(1043);
// EXTERNAL MODULE: ./src/assets/images/icons/left-chevron.png
var left_chevron = __webpack_require__(5751);
// EXTERNAL MODULE: ./src/assets/images/icons/right-chevron.png
var right_chevron = __webpack_require__(8464);
;// CONCATENATED MODULE: ./src/assets/images/icons/search-black-icon.png
/* harmony default export */ var search_black_icon = ({"src":"/_next/static/media/search-black-icon.5049bf73.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAW0lEQVR42kXBIQ6CAAAAwFOmPECzxc0Z3DRK4QU8gvEACAQGARoJSIyN9/AxIneQG1VmCQIKKaAXwYSTC+46aHDFWaiFRQj4yiE2ebv523yAl1It8zN4EDg8rTt0GQyHIT4p0QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/pages/all/[id].js




















var Shop = function(query) {
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var intl = (0,useIntl/* default */.Z)();
    var queryData = query.item;
    var excludedProductIds = [
        920,
        951,
        919,
        867,
        865,
        746,
        733,
        717,
        705,
        570,
        513,
        436,
        413,
        401,
        393,
        391,
        273,
        388,
        270,
        264,
        253,
        245,
        217,
        210,
        179,
        177,
        176,
        172,
        137,
        96,
        86,
        55,
        41,
        17, 
    ];
    var filterExcludedProducts = function(products) {
        if (!Array.isArray(products)) return products;
        if ( true && window.location.hostname === "handle-brand.ru") {
            return products.filter(function(product) {
                return !excludedProductIds.includes(product.id);
            });
        }
        return products;
    };
    var ref3 = (0,react.useState)([]), productList = ref3[0], setProductList = ref3[1];
    var ref4 = (0,react.useState)({
        search: query.search ? query === null || query === void 0 ? void 0 : query.search : ""
    }), state = ref4[0], setState = ref4[1];
    var ref5 = (0,react.useState)(null), productsPage = ref5[0], setProductsPage = ref5[1];
    var ref6 = (0,react.useState)([]), sizeData = ref6[0], setSizeData = ref6[1];
    var ref7 = (0,react.useState)(""), changeCategory = ref7[0], setChangeCategory = ref7[1];
    var ref8 = (0,react.useState)((query === null || query === void 0 ? void 0 : query.changeSize) ? query.changeSize : ""), changeSize = ref8[0], setChangeSize = ref8[1];
    var ref9 = (0,react.useState)([]), allCategory = ref9[0], setAllCategory = ref9[1];
    var ref10 = (0,react.useState)({
        minPrice: (query === null || query === void 0 ? void 0 : query.minPrice) ? query.minPrice : "",
        maxPrice: (query === null || query === void 0 ? void 0 : query.maxPrice) ? query.maxPrice : ""
    }), priceState = ref10[0], setPriceState = ref10[1];
    var currentPageItem = Number(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.item);
    var ref11 = (0,react.useState)((router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.id) ? router.query.id : 1), page = ref11[0], setPage = ref11[1];
    var ref12 = (0,react.useState)(""), hostName = ref12[0], setHostName = ref12[1];
    var currentPageQuery = router.query.id;
    var locale = (0,es/* useSelector */.v9)(function(state) {
        return state.global.locale;
    });
    var getCategoryReq = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var getCategoryReqData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api/* categoryGet_req */.qK)()
                        ];
                    case 1:
                        getCategoryReqData = _state.sent();
                        setAllCategory(getCategoryReqData);
                        return [
                            2
                        ];
                }
            });
        });
        return function getCategoryReq() {
            return _ref.apply(this, arguments);
        };
    }();
    var windowHost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            window.location.hostname
                        ];
                    case 1:
                        data = _state.sent();
                        setHostName(data);
                        return [
                            2
                        ];
                }
            });
        });
        return function windowHost() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var ref;
        if (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.search) {
            searchReq();
        } else {
            if (currentPageItem || (priceState === null || priceState === void 0 ? void 0 : priceState.minPrice) > 0 || (priceState === null || priceState === void 0 ? void 0 : priceState.maxPrice) < 999999) {
                filteredData([
                    currentPageItem
                ], changeSize);
            }
        }
        getFilterSizeData(query.item);
    }, [
        query
    ]);
    (0,react.useEffect)(function() {
        windowHost();
        getCategoryReq();
    }, [
        locale
    ]);
    var handleChange = function(evt) {
        var value = evt.target.value;
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, evt.target.name, value)));
    };
    var getFilterSizeData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            var dataValue, filterReq;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataValue = Number(value);
                        return [
                            4,
                            (0,api/* getFilterSize_req */.aZ)([
                                dataValue
                            ])
                        ];
                    case 1:
                        filterReq = _state.sent();
                        setSizeData(filterReq.data);
                        return [
                            2
                        ];
                }
            });
        });
        return function getFilterSizeData(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var onchangeRadio = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(evt) {
            var value;
            return (0,tslib_es6.__generator)(this, function(_state) {
                value = Number(evt.target.value);
                setChangeCategory(evt.target.name = value);
                setChangeSize("");
                router.push("/all/1?item=".concat(value).concat(priceState.minPrice > 0 ? "&minPrice=".concat(priceState.minPrice) : "").concat(priceState.maxPrice > 0 ? "&maxPrice=".concat(priceState.maxPrice) : ""));
                return [
                    2
                ];
            });
        });
        return function onchangeRadio(evt) {
            return _ref.apply(this, arguments);
        };
    }();
    var onchangeRadioSize = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(evt) {
            var sizeValue;
            return (0,tslib_es6.__generator)(this, function(_state) {
                sizeValue = Number(evt.target.value);
                setChangeSize(evt.target.name = sizeValue);
                router.push("/all/1?item=".concat(query.item, "&changeSize=").concat(sizeValue).concat(priceState.minPrice > 0 ? "&minPrice=".concat(priceState.minPrice) : "").concat(priceState.maxPrice > 0 ? "&maxPrice=".concat(priceState.maxPrice) : ""));
                return [
                    2
                ];
            });
        });
        return function onchangeRadioSize(evt) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangePrice = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(evt) {
            var value;
            return (0,tslib_es6.__generator)(this, function(_state) {
                value = evt.target.value;
                if (evt.target.name === "minPrice") {
                    router.push("/all/1?".concat(router.query.item ? "item=".concat(router.query.item) : changeCategory ? "item=".concat(changeCategory) : "").concat(changeSize > 0 ? "&changeSize=".concat(changeSize) : "").concat(value > 0 ? "&minPrice=".concat(value) : "").concat((priceState === null || priceState === void 0 ? void 0 : priceState.maxPrice) > 0 ? "&maxPrice=".concat(priceState.maxPrice) : ""));
                }
                if (evt.target.name === "maxPrice") {
                    router.push("/all/1?".concat(router.query.item ? "item=".concat(router.query.item) : changeCategory ? "item=".concat(changeCategory) : "").concat(changeSize > 0 ? "&changeSize=".concat(changeSize) : "").concat(priceState.minPrice > 0 ? "&minPrice=".concat(priceState.minPrice) : "").concat(value > 0 ? "&maxPrice=".concat(value) : ""));
                }
                setPriceState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, priceState), (0,_define_property/* default */.Z)({}, evt.target.name, value)));
                return [
                    2
                ];
            });
        });
        return function handleChangePrice(evt) {
            return _ref.apply(this, arguments);
        };
    }();
    var searchReq = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var searchData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api/* search_req */.QR)(state.search, currentPageQuery ? currentPageQuery : 1)
                        ];
                    case 1:
                        searchData = _state.sent();
                        if (searchData) {
                            setPriceState({
                                minPrice: "",
                                maxPrice: ""
                            });
                        }
                        // router.push(`/all/1`);
                        setProductsPage(searchData);
                        setProductList(filterExcludedProducts(searchData === null || searchData === void 0 ? void 0 : searchData.products));
                        return [
                            2
                        ];
                }
            });
        });
        return function searchReq() {
            return _ref.apply(this, arguments);
        };
    }();
    var goSearch = function() {
        router.push("/all/1?search=".concat(state.search));
    };
    // const getProduct = async (data) => {
    //   const getProductData = await getProducts_req(data ? data : page);
    //   setProductsPage(getProductData);
    //   setProductList(getProductData.products);
    // };
    // useEffect(() => {
    //   if (state?.search?.length > 2) {
    //     searchReq();
    //   }else{
    //   }
    // }, [state?.search]);
    var filteredData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data, first, page) {
            var dataQuery, ref, filterReq, ref1, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataQuery = Number(data);
                        if (!(dataQuery > 0 || currentPageItem > 0 || (priceState === null || priceState === void 0 ? void 0 : priceState.minPrice) > 0 || (priceState === null || priceState === void 0 ? void 0 : priceState.maxPrice) < 999999)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,api/* filterProducts_req */.D4)(data && dataQuery > 0 ? [
                                dataQuery
                            ] : currentPageItem > 0 ? [
                                currentPageItem
                            ] : [], first ? first : undefined, priceState, currentPageQuery ? currentPageQuery : page)
                        ];
                    case 1:
                        filterReq = _state.sent();
                        setProductsPage(filterReq.data);
                        setProductList(filterExcludedProducts(filterReq === null || filterReq === void 0 ? void 0 : (ref = filterReq.data) === null || ref === void 0 ? void 0 : ref.filteredProducts));
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            (0,api/* getAllProduct_req */.rE)(currentPageQuery ? currentPageQuery : page)
                        ];
                    case 3:
                        response = _state.sent();
                        setProductsPage(response.data);
                        setProductList(filterExcludedProducts(response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.products));
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function filteredData(data, first, page) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleKeyDown = function(event) {
        if (event.key === "Enter") {
            goSearch();
        }
    };
    var handleClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var ref, ref1, index, ref2, ref3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                index = data.selected;
                setPage(index + 1);
                if (((ref = state.search) === null || ref === void 0 ? void 0 : ref.length) > 1 || (query === null || query === void 0 ? void 0 : (ref1 = query.search) === null || ref1 === void 0 ? void 0 : ref1.length) > 1) {
                    ;
                    router.push("/all/".concat(index + 1, "?search=").concat((state === null || state === void 0 ? void 0 : (ref2 = state.search) === null || ref2 === void 0 ? void 0 : ref2.length) > 1 ? state === null || state === void 0 ? void 0 : state.search : query === null || query === void 0 ? void 0 : query.search));
                } else {
                    ;
                    if (router) {
                        router.push("/all/".concat(index + 1, "?").concat(router.query.item ? "item=".concat(router.query.item) : "item=".concat(changeCategory)).concat(changeSize > 0 ? "&changeSize=".concat(changeSize) : "").concat(priceState.minPrice > 0 ? "&minPrice=".concat(priceState.minPrice) : "").concat(priceState.maxPrice > 0 ? "&maxPrice=".concat(priceState.maxPrice) : ""));
                    } else if (!router.query.item && ((priceState === null || priceState === void 0 ? void 0 : priceState.minPrice) == 0 || (priceState === null || priceState === void 0 ? void 0 : (ref3 = priceState.minPrice) === null || ref3 === void 0 ? void 0 : ref3.length) === 0)) {
                        router.push("/all/".concat(index + 1));
                    }
                }
                return [
                    2
                ];
            });
        });
        return function handleClick(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var meta = (0,react.useMemo)(function() {
        return {
            title: "Հուշանվերների Խանութսրահ | Ձեռքի Աշխատանքներ | Handle",
            description: "Ցանկանում ես գնել բնական փայտից  կոնյակի տակառ, ժամացույց, շախմատ, նարդի, ձեռնափայտ և այլ հուշանվերներ | Իմացիր ավելին այստեղ"
        };
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        meta: meta,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "shop",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(banner/* default */.Z, {
                    title: "".concat((query === null || query === void 0 ? void 0 : query.discount) === "discount" ? intl.messages.discount : intl.messages.shop),
                    currentPage: "".concat((query === null || query === void 0 ? void 0 : query.discount) === "discount" ? intl.messages.discount : intl.messages.shop)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "filter-section flex flex-ai-center flex-jc-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "filter-left flex flex-ai-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_select/* default */.Z, {
                                            label: intl.messages.category,
                                            handleChange: onchangeRadio,
                                            name: "changeCategory",
                                            value: currentPageItem ? currentPageItem : changeCategory,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    !currentPageItem && /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "",
                                                        disabled: true,
                                                        children: intl.messages.selectOne
                                                    }),
                                                    allCategory === null || allCategory === void 0 ? void 0 : (ref2 = allCategory.data) === null || ref2 === void 0 ? void 0 : ref2.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: item.categoryId,
                                                            selected: changeCategory ? changeCategory === item.categoryId : queryData === item.id,
                                                            children: item.name
                                                        });
                                                    })
                                                ]
                                            })
                                        }),
                                        (sizeData === null || sizeData === void 0 ? void 0 : sizeData.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "filter-category",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_select/* default */.Z, {
                                                label: intl.messages.size,
                                                handleChange: onchangeRadioSize,
                                                name: intl.messages.size,
                                                value: changeSize,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "",
                                                            disabled: true,
                                                            children: intl.messages.selectOne
                                                        }),
                                                        sizeData === null || sizeData === void 0 ? void 0 : sizeData.map(function(item, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: item.id,
                                                                selected: item.id,
                                                                children: item.name
                                                            });
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "field-item price-range",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: intl.messages.priceRange
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "number",
                                                            placeholder: intl.messages.from,
                                                            onChange: handleChangePrice,
                                                            value: priceState.minPrice,
                                                            name: "minPrice"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "number",
                                                            placeholder: intl.messages.to,
                                                            onChange: handleChangePrice,
                                                            value: priceState.maxPrice,
                                                            name: "maxPrice"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "filter-right",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "field-item search-field",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: intl.messages.search
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: "search-label",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: handleChange,
                                                        value: state.search,
                                                        name: "search",
                                                        onKeyDown: handleKeyDown
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        onClick: goSearch,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: search_black_icon.src,
                                                            alt: ""
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-wrap",
                            children: productList.length > 0 ? productList === null || productList === void 0 ? void 0 : productList.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productItem/* default */.Z, {
                                        image: item.image,
                                        name: item.title,
                                        size: item.size,
                                        price: item.price,
                                        code: item.code,
                                        categoryName: item.categoryName,
                                        tag: item.discount,
                                        oldPriceData: true,
                                        id: item.id,
                                        currency: item.currency,
                                        changeSize: changeSize,
                                        minPrice: priceState.minPrice,
                                        maxPrice: priceState.maxPrice
                                    })
                                });
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-not-found",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: browser/* default.src */.Z.src,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: intl.messages.productNotFound
                                    })
                                ]
                            })
                        }),
                        (productsPage === null || productsPage === void 0 ? void 0 : productsPage.pagesCount) > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
                            previousLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: left_chevron/* default.src */.Z.src,
                                alt: ""
                            }),
                            nextLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: right_chevron/* default.src */.Z.src,
                                alt: ""
                            }),
                            breakLabel: "...",
                            pageCount: productsPage === null || productsPage === void 0 ? void 0 : productsPage.pagesCount,
                            marginPagesDisplayed: 1,
                            pageRangeDisplayed: 3,
                            onPageChange: function(data) {
                                return handleClick(data);
                            },
                            containerClassName: "pagination justify-content-center",
                            pageClassName: "page-item",
                            pageLinkClassName: "page-link",
                            previousClassName: "page-item",
                            previousLinkClassName: "page-link",
                            nextClassName: "page-item",
                            nextLinkClassName: "page-link",
                            breakClassName: "page-item",
                            breakLinkClassName: "page-link",
                            activeClassName: "active",
                            forcePage: currentPageQuery - 1
                        }) : null
                    ]
                })
            ]
        })
    });
};
Shop.getInitialProps = function(param) {
    var query = param.query;
    return query;
};
/* harmony default export */ var _id_ = (Shop);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [962,940,774,888,179], function() { return __webpack_exec__(6078); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);